import useMember from "./useMember";
import { memberLogout } from "../api/apiServices"

const useMemLogout = () => {
    const { setMem } = useMember();

    const logout = async () => {
        setMem({});
        try {
            memberLogout();
        } catch (err) {
            console.error(err);
        }
    }
    return logout;
}

export default useMemLogout;
